import { mdiPackageVariantClosed } from '@mdi/js'

export default {
  title: 'Promotion',
  to: 'promotion-admin',
  icon: mdiPackageVariantClosed,
  action: 'read',
  resource: 'PromotionAdmin',
}
